module.exports = __webpack_public_path__ + "static/media/list_3.a3a93d2f.svg";